/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import {Group, Tip} from '@insticator/insticator-ui'; // iui-material
import DropdownMenuItem from 'material/embeds/labelassignmentfield/dropdownmenuitem/dropdownmenuitem';
import LabelAssignmentCollection from 'material/embeds/labelassignmentfield/labelassignmentcollection/labelassignmentcollection';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/labelassignmentfield_styles';
import Field from 'material/embeds/labelassignmentfield/field/field';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT FIELD : CHILD ~~~~~~~~~~ ========== */
class LabelAssignmentField extends Component {
    constructor(props) {
        super(props);
        this.labelAssignmentFieldElement = React.createRef();
        this.state = {
            focus: false,
            showMenu: false,
            enteredLabelName: '',
            valid: true
        };
    }

    componentDidMount() {
        return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }

    handleChange = (event) => {
        const enteredName = event.target.value;
        const valid = /^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/.test(enteredName);
        this.setState({ enteredLabelName: enteredName, valid });
        if(enteredName && !this.isEmptyString(enteredName) && !this.state.showMenu) this.showMenu()
        if (this.isEmptyString(enteredName) && this.state.showMenu) this.hideMenu();
    };

    isEmptyString = string => !string.replace(/\s/g, '').length;

    toggleFocus = () => this.setState({ focus: !this.state.focus });

    handleOutsideClick = (e) => {
        if (!this.labelAssignmentFieldElement.current.contains(e.target)) this.hideMenu();
    };

    showMenu = () => this.setState({ showMenu: true });

    hideMenu = () => this.setState({ showMenu: false });

    handleCreateLabel = (labelName) => {
        const labelUUID = this.getLabelUUIDByName(labelName);
        if (!!labelUUID) {
            if(!this.props.blockSelect) this.handleSelectLabel(labelUUID);
            return null;
        }
        this.props.createLabel(this.props.accountUUID, labelName, (response) => this.handleSelectLabel(response))
    };

    handleSelectLabel = (labelUUID) => {
        if(this.props.attachedLabelUUIDs.includes(labelUUID)) return null;
        this.props.attachLabel(labelUUID);
        this.setState({ focus: true, showMenu: false, enteredLabelName: '', valid: true })
    };

    handleRemoveLabel = (labelUUID) => {
        if(!this.props.attachedLabelUUIDs.includes(labelUUID)) return null;
        this.props.removeLabel(labelUUID)
    };

    getLabelUUIDByName = (labelName) => Object.keys(this.props.labels).find(labelUUID => this.props.labels[labelUUID] === labelName);

    getCreateLabelItem = () => <DropdownMenuItem key={`${this.state.enteredLabelName}`}
                                                 handleSelect={this.handleCreateLabel}
                                                 searchTerm={''}
                                                 itemName={`${this.state.enteredLabelName} (Create label)`}
                                                 itemSelected={false}
                                                 itemValue={this.state.enteredLabelName}/>;

    getDropdownItems = () => {
        const hasMatchingLabel = Object.values(this.props.labels).includes(this.state.enteredLabelName);
        const enteredValidName = this.state.valid && !!this.state.enteredLabelName;
        const initialDropDownItems = [...hasMatchingLabel || !enteredValidName ? [] : [this.getCreateLabelItem()]];

        return Object.keys(this.props.labels).reduce((result, labelUUID) => {
            const isLabelAttached = this.props.attachedLabelUUIDs.includes(labelUUID);
            const nameMatchesSearch = this.props.labels[labelUUID].startsWith(this.state.enteredLabelName);
            if (nameMatchesSearch && !isLabelAttached) {
                result.push(<DropdownMenuItem key={`${labelUUID}`}
                                              handleSelect={!this.props.blockSelect ? this.handleSelectLabel : this.hideMenu}
                                              searchTerm={this.state.enteredLabelName}
                                              itemName={this.props.labels[labelUUID]}
                                              itemValue={labelUUID}/>)
            }
            return result;
        }, initialDropDownItems);
    };

    renderDropdownMenu = () => {
        const dropdownItems = this.getDropdownItems();
        return(
            <Group name={`dropdownmenu active-${this.state.showMenu && !!dropdownItems.length}`}  >
                <Group name={`dropdownmenuitems`}>
                    {dropdownItems}
                </Group>
            </Group>
        )
    };

    render() {
        return(
            <div className={`labelassignmentfield ${this.props.classes.labelassignmentfield}`} ref={this.labelAssignmentFieldElement}>
                <Field active={this.state.focus}
                       errorMessage={'Enter valid label name'}
                       valid={this.state.valid || !this.state.enteredLabelName}
                       hasValue={true}
                       label={(
                           <span className={'assignmentfieldlabel'}>
                               <p>Add label(s)</p>
                               <Tip space={`left`} content={`Start typing to create your label`} />
                           </span>
                       )}
                       required={true}
                       component={
                           <LabelAssignmentCollection attachedLabelUUIDs={this.props.attachedLabelUUIDs}
                                                      removeLabel={this.handleRemoveLabel}
                                                      labels={this.props.labels}
                                                      enteredLabelName={this.state.enteredLabelName}
                                                      onChange={this.handleChange}
                                                      onKeyDown={this.handleChange}
                                                      createLabel={this.handleCreateLabel}
                           />
                       }
                />
                {this.renderDropdownMenu()}
            </div>
        );
    }
}





/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LabelAssignmentField);
